import { createTheme } from '@mui/material/styles';

import { brandFontFamily } from '../../styles/layout.module.scss';

export const theme = createTheme({
  typography: {
    fontFamily: brandFontFamily,
  },
});
